import React, { Suspense, useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import Viewport from './viewport';
import { RouteParams } from '@interfaces/portal';
import RootStore from './stores';
const Portal = React.lazy(() => import('@pages/portal'));
const TNC = React.lazy(() => import('@pages/tnc'));


const Routes: React.FC<RouteParams> = (props) => {
    const {lang} = props;
    const { setLangTag } = RootStore.BasicInfoStore;

    /**
     * set lang from parent component location.pathname
     */
    useEffect(() => {
        setLangTag(lang);
    }, [lang]);

    return (
        <RouterHooks>
            <Viewport>
                <Suspense fallback={<div></div>}>
                    <Switch>
                        <Route path={`/${lang}/tnc`} exact>
                            <TNC lang={lang} />
                        </Route>
                        <Route path={`/${lang}`} exact>
                            <Portal lang={lang} />
                        </Route>
                    </Switch>
                </Suspense>
            </Viewport>
        </RouterHooks>
    );
};

const RouterHooks: React.FC = (props) => {
    // const history = useHistory();
    // useEffect(() => {
    //     const { pathname } = history.location;
    // }, [history]);

    return <>{props.children}</>;
};

export default Routes;
